import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  manageTemplatesModalTitle: {
    description: 'Manage import templates modal title',
    defaultMessage: 'Manage Import Templates',
    id: 'SjPIFM',
  },
  manageTemplatesModalBodyMessage: {
    description: 'Manage import templates modal body message',
    defaultMessage: 'Rename or delete import templates.',
    id: 'rwCUsU',
  },
  manageTemplatesModalNoTemplates: {
    description: 'Manage import templates modal message when no templates defined',
    defaultMessage: 'You have no import templates defined',
    id: 'IjvYj1',
  },
  confirmDeleteModalTitle: {
    description: 'Confirm import template deletion modal title',
    defaultMessage: 'Delete Template',
    id: 'Py3xOW',
  },
  confirmDeleteModalBodyMessage: {
    description: 'Confirm import template deletion modal body message',
    defaultMessage: 'Are you sure you want to delete import template "{mappingName}"?',
    id: 'USTamf',
  },
  confirmDeleteModalCancelButton: {
    description: 'Confirm import template deletion modal cancel button message',
    defaultMessage: 'Cancel',
    id: 'aaS1fu',
  },
  confirmDeleteModalDeleteButton: {
    description: 'Confirm import template deletion modal delete button message',
    defaultMessage: 'Delete',
    id: 'ASt45O',
  },
  templatesTableNameHeader: {
    description: 'Import templates table name header',
    defaultMessage: 'Name',
    id: 'ndQXCa',
  },
  templatesTableActionsHeader: {
    description: 'Import templates table actions header',
    defaultMessage: 'Actions',
    id: 'GnmsNK',
  },
  templateRowEditButton: {
    description: 'Import template row edit button message',
    defaultMessage: 'Rename',
    id: 'TQftlA',
  },
  templateRowDeleteButton: {
    description: 'Import template row delete button message',
    defaultMessage: 'Delete',
    id: 'NVEnwU',
  },
  templateNameInputPlaceholder: {
    description: 'Import template name input placeholder',
    defaultMessage: 'Enter template name',
    id: 'ekUBdC',
  },
  templateNameRequiredMessage: {
    description: 'Import template name is required message',
    defaultMessage: 'Template name is required',
    id: '6uadEg',
  },
  templateNameRepeatedMessage: {
    description: 'Import template name is repeated message',
    defaultMessage: 'Template name has to be unique',
    id: 'DWOTiD',
  },
  templateRowSaveButton: {
    description: 'Import template row save button message',
    defaultMessage: 'Save',
    id: 'U+JmDC',
  },
  templateRowCancelButton: {
    description: 'Import template row cancel button message',
    defaultMessage: 'Cancel',
    id: 'bgjfdd',
  },
  renameTemplateErrorTitle: {
    description: 'Error renaming import template title',
    defaultMessage: 'Error renaming import template',
    id: 'Xkrnjr',
  },
  renameTemplateErrorMessage: {
    description: 'Error renaming import template message',
    defaultMessage: 'ShipStation could not rename import template.',
    id: 'he6opK',
  },
  deleteTemplateErrorTitle: {
    description: 'Error deleting import template title',
    defaultMessage: 'Error deleting import template',
    id: 'DgxIbI',
  },
  deleteTemplateErrorMessage: {
    description: 'Error deleting import template message',
    defaultMessage: 'ShipStation could not delete import template.',
    id: 'GKhE+x',
  },
});
